module.exports = __webpack_public_path__ + "img/gif.f3b83372.svg";